import { get } from 'lodash';
import React, { useEffect } from 'react';
import { ScrollView } from 'react-native';
import ReactNativeModal from 'react-native-modal';
import { SeatLayoutProps, SeatProps } from 'src/common/api/response';
import { useSeatDetailsQuery } from 'src/common/hooks';
import { Center, Container, EmptyState, PrimaryButton, RegularText } from 'src/components';
import { Navigation } from 'src/navigations/RootNavigation';
import { SeatLayout } from 'src/screens/selectSeat/components/SeatLayout';
import { device, metrics } from 'src/themes/Metrics';

export const SeatLayoutModal = ({
  tripId,
  date,
  isVisible,
  onClose,
  passengerSeats,
}: // setSeatSelected,
{
  tripId: string;
  date: Date;
  isVisible: boolean;
  onClose: () => void;
  passengerSeats: SeatProps[];
  // setSeatSelected: (seats: SeatProps[]) => void;
}) => {
  const {
    data: seatDetail,
    isFetching,
    isError,
    refetch,
    error,
  } = useSeatDetailsQuery({
    tripId,
    date,
  });
  // const layout = useMemo(())
  const [vehicleSeatLayout, setVehicleSeatLayout] = React.useState<SeatLayoutProps[]>();

  React.useEffect(() => {
    if (!seatDetail) return;
    if (seatDetail.seatLayouts.length === 0) return;

    // const keys = Object.keys(seatDetail.seatLayouts[0].decks);
    // if (keys.length === 0) return;

    // if (seatDetail.seatLayouts[0].decks.length === 0) return;

    setVehicleSeatLayout(seatDetail.seatLayouts);
  }, [seatDetail]);

  useEffect(() => {
    refetch();
  }, []);

  const handleBookingPress = () => {
    onClose();

    Navigation.push('SelectSeatScreen');
  };

  return (
    <ReactNativeModal isVisible={isVisible} onBackButtonPress={onClose} onBackdropPress={onClose}>
      <Container
        padding={metrics.large}
        paddingTop={0}
        borderRadius={metrics.borderRadius}
        style={{
          minHeight: device.height * 0.55,
          maxHeight: device.height * 0.8,
        }}
        backgroundColor="rgba(255, 255, 255, 0.7)">
        {isFetching || isError ? (
          <Center flex>
            <EmptyState loading={isFetching} error={error} text="tripEmptyContent" />
          </Center>
        ) : (
          <>
            <Container paddingTop={metrics.huge}>
              <RegularText textAlign="center" fontWeight="bold" fontSize="larger" textLang="availableSeats" />
            </Container>
            <ScrollView
              showsVerticalScrollIndicator={false}
              style={{ paddingTop: metrics.huge, paddingBottom: metrics.large }}>
              <SeatLayout
                showIndicator={false}
                width="100%"
                channel=""
                viewOnly
                passengerSeats={passengerSeats}
                // seatLayout={get(vehicleSeatLayout, `layout`, undefined) as SeatProps[][] | undefined}
                transitId={get(vehicleSeatLayout, '[0].transitId', '')}
                seatLayout={get(vehicleSeatLayout, '[0].decks[0].layout', undefined)}
              />
            </ScrollView>
            <PrimaryButton onPress={handleBookingPress} text="continueToBooking" />
          </>
        )}
      </Container>
    </ReactNativeModal>
  );
};
